export default /* istanbul ignore next */ ({ palette }) => ({
  root: {
    display: 'inline-block',
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: 10,
    height: 32,
    backgroundColor: palette.background.primary,
  },
});
